// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__ZnhpB","header":"ClearentDisclaimer_header__2Xdmj","inner":"ClearentDisclaimer_inner__1nFgn"};